var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25003 10.1945C1.05043 10.1945 0.888916 10.3561 0.888916 10.5556C0.888916 10.755 1.05043 10.9167 1.25003 10.9167H7.75003C7.94963 10.9167 8.11114 10.755 8.11114 10.5556C8.11114 10.3561 7.94963 10.1945 7.75003 10.1945H1.25003Z",
    fill: "#181038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65272 0.444485C8.65272 0.245063 8.49121 0.083374 8.29161 0.083374H6.84717C6.64757 0.083374 6.48606 0.245063 6.48606 0.444485C6.48606 0.643907 6.64757 0.805596 6.84717 0.805596H7.20828V5.96941C7.20828 7.46288 5.99341 8.67775 4.49995 8.67775C3.00648 8.67775 1.79161 7.46288 1.79161 5.96941V0.805596H2.15272C2.35232 0.805596 2.51383 0.643907 2.51383 0.444485C2.51383 0.245063 2.35232 0.083374 2.15272 0.083374H0.708279C0.508681 0.083374 0.347168 0.245063 0.347168 0.444485C0.347168 0.643907 0.508681 0.805596 0.708279 0.805596H1.06939V5.96941C1.06939 7.86102 2.60834 9.39997 4.49995 9.39997C6.39155 9.39997 7.9305 7.86102 7.9305 5.96941V0.805596H8.29161C8.49121 0.805596 8.65272 0.643907 8.65272 0.444485Z",
    fill: "#181038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineSmall);
export default __webpack_public_path__ + "static/media/underline-small.1af53529d3aeb01414b0740dbe81007c.svg";
export { ForwardRef as ReactComponent };